<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0925 3.09996C11.4519 2.30001 12.5481 2.30001 12.9075 3.09996L15.1203 8.02508L21.1205 8.79554C21.9503 8.90209 22.2961 9.95459 21.702 10.565L17.5695 14.8101L18.3875 20.1572C18.5166 21.0015 17.6626 21.6373 16.9331 21.2399L12 18.5526L7.06686 21.2399C6.33739 21.6373 5.48337 21.0015 5.61253 20.1572L6.43049 14.8101L2.29804 10.565C1.70386 9.95459 2.04973 8.90209 2.87952 8.79554L8.87967 8.02508L11.0925 3.09996Z"
      fill="currentColor"
    />
  </svg>
</template>
